const doc = [({"en":({"adminConstantHotelPriceUpdateType":({"absolute":"Set the price", "relative":"Adjust the original price"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;